import React from 'react';
import { Translate } from 'react-localize-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './FiltersSectionHeader.css';
import Icon, { IconSizes, IconVariants } from '../../foundations/Icon';

export const FILTERS_AMOUNT_TEXT = 'STATIC.FILTERS_SECTION.FILTERS_AMOUNT';
export const CLEAR_FILTERS_TEXT = 'STATIC.FILTERS_SECTION.CLEAR_FILTERS';

const FiltersSectionHeader = ({
    onClearClicked,
    expanded = true,
    setExpanded,
    appliedFiltersCount = 0,
    disabled = false,
    title,
    icon,
}) => {
    return (
        <div className={css.header}>
            <div className={css.title}>
                <Icon name={icon} interactive={false} />
                <Translate id={title} />
                {!!appliedFiltersCount && (
                    <div className={css.filtersIndication}>
                        <Translate id={FILTERS_AMOUNT_TEXT} data={{ count: appliedFiltersCount }} />
                        <div className={classNames(css.clear, { [css.disabled]: disabled })} onClick={onClearClicked}>
                            <Icon
                                name="eraser"
                                variant={IconVariants.ACTIVE}
                                disabled={disabled}
                                size={IconSizes.MEDIUM}
                            />
                            <Translate id={CLEAR_FILTERS_TEXT} />
                        </div>
                    </div>
                )}
            </div>
            <Icon
                name={expanded ? 'arrows-diagonal-minimize-2' : 'arrows-diagonal'}
                className={css.collapsedIcon}
                onClick={() => setExpanded(value => !value)}
            />
        </div>
    );
};

FiltersSectionHeader.propTypes = {
    onClearClicked: PropTypes.func,
    expanded: PropTypes.bool,
    setExpanded: PropTypes.func,
    appliedFiltersCount: PropTypes.number,
    disabled: PropTypes.bool,
    title: PropTypes.string,
    icon: PropTypes.string,
};

export default FiltersSectionHeader;
